import React from 'react';
import styled from 'react-emotion';
//import { SectionHeading } from './ProductInfo';
import BaseSizePicker from './SizePicker';
import { SelectDropdown } from '@jetshop/ui/Select';
import Quantity from './Quantity';
import OptionSwitch from '@jetshop/core/components/OptionSwitch';
import { Label } from '../Forms/Input';

const Wrapper = styled('div')`
  width: 100%;
  display: flex;
`;

const QtySelector = styled('div')`
  flex: 1 auto;
  max-width: 25%;
  padding-right: 1rem;
`;

const SizeSelector = styled('div')`
  flex: 1 auto;
`;

const PickerWrapper = styled('div')`
  width: 100%;
`;

const SizePicker = ({ option, ...props }) =>
  console.log(props) || (
    <PickerWrapper>
      <Label>{option.name}</Label>
      <BaseSizePicker
        data-testid={`${option.name}-select-dropdown`}
        {...props}
      />
    </PickerWrapper>
  );

const DefaultPicker = ({ option, error, ...props }) =>
  console.log(props) || (
    <PickerWrapper>
      <Label>{option.name}</Label>
      <SelectDropdown
        data-testid={`${option.name}-select-dropdown`}
        {...props}
        defaultSelectedItem={props && props.items && props.items[0]}
      />
    </PickerWrapper>
  );

const Selectors = ({ quantity, setQuantity, variants, setValues, values }) => {
  return (
    <Wrapper>
      <QtySelector>
        <Quantity
          defaultValue={quantity}
          onChange={e => {
            setQuantity(e.value);
            setValues({ ...values, quantity: e.value });
          }}
          name="Quantity"
        />
      </QtySelector>

      <OptionSwitch
        components={{
          Storlekar: SizePicker,
          Size: SizePicker,
          default: DefaultPicker
        }}
      />
    </Wrapper>
  );
};
export default Selectors;
